import { render, staticRenderFns } from "./TheCommentsModal.vue?vue&type=template&id=1e51cf91&"
import script from "./TheCommentsModal.vue?vue&type=script&lang=js&"
export * from "./TheCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./TheCommentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports